import { render, staticRenderFns } from "./EcsEmailReply.vue?vue&type=template&id=fd45e910&scoped=true"
import script from "./EcsEmailReply.vue?vue&type=script&lang=js"
export * from "./EcsEmailReply.vue?vue&type=script&lang=js"
import style0 from "./EcsEmailReply.vue?vue&type=style&index=0&id=fd45e910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd45e910",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F17924097%2FAWC-BS4-DB%2Fsrc%2Fcomponents%2Fecs-email%2Fecs-email-reply%2FEcsEmailReply.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports